<template>
  <div style="width: 100%;">
    <!--联系我们-->
    <div class="contact-us">
      <div style="height: 74px;"></div>
      <div class="contact-us-txt">联系我们，开启您的成功之旅！</div>
      <div class="input-box" style="margin-top: 34px;">
        <div class="phone-box">
          <input class="phone" type="tel" style="::placeholder { color: white; }" placeholder="请输入电话"
            v-model="telephone" />
        </div>

        <div class="select-box">
          <el-dropdown @command="handleCommand" trigger="click" :visible.sync="dropdownVisible">
            <span class="el-dropdown-link" style="display: flex; align-items: center;">
              <div class="serve-txt" style="width: 160px;">{{ serveTxt }}</div>
              <div style="width:13px;"></div>
              <img src="../../assets/xiala.png" style="width:12px; height:6px;" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="职业规划咨询">职业规划咨询</el-dropdown-item>
              <el-dropdown-item command="院校合作">院校合作</el-dropdown-item>
              <el-dropdown-item command="企业人才合作">企业人才合作</el-dropdown-item>
              <el-dropdown-item command="加入导师团队">加入导师团队</el-dropdown-item>
              <el-dropdown-item command="其他合作/商务咨询">其他合作/商务咨询</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <div style="width:22px;"></div>
        </div>


        <div class="submit" @click="submitData">立即提交</div>
      </div>
    </div>
    <!--公司信息-->
    <div class="company-information">
      <div style="height:60px;"></div>
      <div class="content-area">
        <div class="content-text">
          <img src="../../assets/logo_horizontal_layout.png" style="width:190px; height:47px;" />
          <div style="height:19px;"></div>
          <div class="contact-us-text">联系我们</div>
          <div style="height:14px;"></div>
          <div class="tel">Tel：18116007179</div>
          <div style="height:14px;"></div>
          <div class="email">E-mail：qcwy@passionpanda.cn</div>
        </div>
        <div class="qr-code">
<!--          <div class="code-box">-->
<!--            <img src="../../assets/little_assistant.png" class="code" />-->
<!--            <div class="introduction">添加小助手</div>-->
<!--          </div>-->
          <div class="code-box">
            <img src="../../assets/official_account.png" class="code" />
            <div class="introduction">关注公众号</div>
          </div>
          <div class="code-box">
            <img src="../../assets/douyin.png" class="code" />
            <div class="introduction">关注抖音号</div>
          </div>
          <div class="code-box">
            <img src="../../assets/video_account.png" class="code" />
            <div class="introduction">关注视频号</div>
          </div>
        </div>
      </div>
      <div style="height:40px;"></div>
      <!--分割线-->
      <div class="dividing-line"></div>
      <div style="height:16px;"></div>
      <!--版权-->
      <div class="copyright">
        <div>© 2025 启乘无忧管理咨询有限公司 保留所有权利</div>
        <div>
          <a href="https://beian.miit.gov.cn/" style="color:#999999; text-decoration: none;">
            苏ICP备2025158933号-1
          </a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'contactUs',
  data() {
    return {
      dropdownVisible: true,
      telephone:'',
      serveTxt: "请选择您要咨询的服务",
      consultationType: '',
    }
  },
  methods: {
    handleCommand(value) {
      this.serveTxt = value;
    },

    //筛选出咨询类型
    screening(){
      if(this.serveTxt == '请选择您要咨询的服务'){
         this.$message({
          message: '请先选择您要咨询的服务',
          type: 'warning'
        });
        return false;
      }else if(this.serveTxt == '职业规划咨询'){
        this.consultationType = '1';
      }else if(this.serveTxt == '院校合作'){
        this.consultationType = '2';
      }else if(this.serveTxt == '企业人才合作'){
        this.consultationType = '3';
      } else if(this.serveTxt == '加入导师团队'){
        this.consultationType = '4';
      }else if(this.serveTxt == '其他合作/商务咨询'){
        this.consultationType = '5';
      }
      return true;
    },

    //验证手机号
    verification(){
       const regex = /^1[3-9]\d{9}$/;
       if (!this.telephone) {
        this.$message({
          message: '手机号码不能为空',
          type: 'warning'
        });
        return false;
      } else if (!regex.test(this.telephone)) {
        this.$message({
          message: '请输入有效的手机号',
          type: 'warning'
        });
        return false;
      }
      return true;
    },

     async submitData() {
        if(!this.verification()){
          return;
        }

        if(!this.screening()){
           return;
        }

        try {
          const requestData = {
            mobileNumber: this.telephone,
            consultationType: this.consultationType
          };
          const response = await fetch(
            'https://api-prod.passionpanda.cn/web/consultation/save',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(requestData)  // 转为 JSON 字符串
            }
          );
          // 检查响应状态
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          // 解析响应数据
          const data = await response.json();
          this.telephone = ''
          this.serveTxt = "请选择您要咨询的服务"
          this.$message({
           message: '提交成功',
           type: 'success'
          });
        } catch (error) {
           this.$message({
            message: '提交失败',
            type: 'warning'
          });
        }
      }

  }
}
</script>

<style lang="scss" scoped>
.contact-us {
  min-height: 296px;
  background-image: url("../../assets/contact-us.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  .contact-us-txt {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 36px;
    color: #FFFFFF;
    line-height: 50px;
    text-align: center;
    font-style: normal;
  }

  .input-box {
    width: 741px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;

    .select-box {
      width: 236px;
      height: 48px;
      border-radius: 24px;
      border: 2px solid #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      cursor: pointer;

      .serve-txt {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 22px;
        text-align: left;
        font-style: normal;
      }
    }

    .phone-box {
      width: 277px;
      height: 48px;
      border-radius: 24px;
      border: 2px solid #FFFFFF;
      display: flex;
      justify-content: flex-end;

      .phone::placeholder {
        color: #FFFFFF;
        font-weight: 400;
        font-size: 16px;
      }

      .phone:-ms-input-placeholder {
        /* IE 10-11 */
        color: #FFFFFF;
        font-weight: 400;
        font-size: 16px;
      }

      .phone::-ms-input-placeholder {
        /* Edge */
        color: #FFFFFF;
        font-weight: 400;
        font-size: 16px;
      }

      .phone {
        width: 247px;
        height: 48px;
        background: transparent;
        border-radius: 24px;
        border: none;
        outline: none;
        font-size: 16px;
        color: #FFFFFF;
      }
    }
  }

  .submit {
    width: 180px;
    height: 48px;
    background: linear-gradient(343deg, #FFE1C6 0%, #FFFBF3 100%);
    border-radius: 24px;
    border: 2px solid #FFFFFF;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 18px;
    color: #171A1D;
    line-height: 25px;
    text-align: center;
    font-style: normal;
    line-height: 48px;
    cursor: pointer;
  }


  .submit:hover {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 18px;
    color: #FF6E00;
    line-height: 25px;
    text-align: center;
    font-style: normal;
    line-height: 48px;
  }



}

.company-information {
  height: 380px;
  background: #171A1D;

  .copyright {
    display: flex;
    width: 1280px;
    margin: 0 auto;
    justify-content: space-between;
    font-family: PingFangSC, PingFang SC;
    font-weight: 300;
    font-size: 16px;
    color: #999999;
    line-height: 40px;
    text-align: left;
    font-style: normal;
  }

  .dividing-line {
    width: 1280px;
    height: 1px;
    background: #999999;
    margin: 0 auto;
  }

  .content-area {
    width: 1280px;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;

    .content-text {
      display: flex;
      flex-direction: column;
      align-content: flex-start;

      .contact-us-text {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 22px;
        text-align: left;
        font-style: normal;
      }

      .tel {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 20px;
        text-align: left;
        font-style: normal;
      }

      .email {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 20px;
        text-align: left;
        font-style: normal;
      }
    }

    .qr-code {
      display: flex;
      width: 540px;
      justify-content: space-between;

      .code-box {
        display: flex;
        flex-direction: column;
        align-items: center;

        .introduction {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #FFFFFF;
          line-height: 20px;
          text-align: left;
          font-style: normal;
          margin-top: 24px;
        }
      }

      .code-box {
        .code {
          width: 108px;
          height: 108px;
          margin-top: 10px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ContactUs/contactUs.vue